import Vue from 'vue'
import firebase from 'firebase'
import Vuelidate from 'vuelidate'
import VueRouter from 'vue-router'
// My components
import store from '@/store'

Vue.use(VueRouter, Vuelidate)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: 70 }
      }
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '*',
      name: 'NOTFOUND',
      component: () =>
        import(/* webpackChunkName: "notfound" */ '@/views/pages/NOTFOUND')
    },
    { path: '*', redirect: `'/404'` },
    {
      path: '/payment/success',
      name: 'PaymentSuccess',
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/pages/payment/PaymentSuccess.vue'
        )
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/SignUp')
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/Login')
    },
    {
      path: '/forgotpassword',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/ForgotPassword')
    },
    {
      path: '/actionUrl',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/ActionUrl')
    },
    {
      path: '/auth',
      name: 'AuthHandler',
      component: () =>
        import(/* webpackChunkName: "auth" */ '@/views/auth/AuthHandler')
    },
    {
      path: '/admin',
      name: 'Admin',
      component: () =>
        import(/* webpackChunkName: "admin" */ '@/views/pages/admin/index')
    },
    {
      path: '/admin/approve-adverts',
      name: 'AdvertsApprove',
      component: () =>
        import(
          /* webpackChunkName: "admin" */ '@/views/pages/admin/AdvertsApprove'
        )
    },
    {
      path: '/admin/email-campaigns',
      name: 'EmailCampaigns',
      component: () =>
        import(
          /* webpackChunkName: "admin" */ '@/views/pages/admin/EmailCampaigns'
        ),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: () =>
        import(
          /* webpackChunkName: "unsubscribe" */ '@/views/pages/Unsubscribe'
        )
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/Dashboard'),
      meta: { requiresAuth: true }
    },
    {
      path: '/favourites',
      name: 'Favourites',
      component: () => import(/* webpackChunkName: "main" */ '@/views/Home'),
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () =>
        import(/* webpackChunkName: "profile" */ '@/views/profile/Index'),
      meta: { requiresAuth: true }
    },
    {
      path: '/advertiser',
      name: 'Advertiser',
      component: () =>
        import(/* webpackChunkName: "advertiser" */ '@/views/pages/Advertiser'),
      meta: { requiresAuth: true }
    },
    {
      path: '/categories',
      name: 'Categories',
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/Categories'),
      meta: { requiresAuth: true }
    },
    {
      path: '/rss-feeds',
      name: 'RssFeeds',
      component: () =>
        import(/* webpackChunkName: "main" */ '@/views/RssFeeds'),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace',
      name: 'WorkspaceDashboard',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/WorkspaceDashboard.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace/auth',
      name: 'TeamsWorkSpaceAuth',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/TeamsWorkSpaceAuth.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace/members',
      name: 'WorkspaceMembers',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/WorkspaceMembers.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace/search',
      name: 'WorkspaceSearch',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/WorkspaceSearch.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspaces',
      name: 'WorkspaceList',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/WorkspaceList.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace/:slug',
      name: 'TeamsWorkSpaceSlug',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/TeamsWorkSpace.vue'
        ),
      meta: { requiresAuth: true }
    },
    {
      path: '/teams/workspace/:workspaceId/:slug',
      name: 'TeamsWorkSpacePublic',
      component: () =>
        import(
          /* webpackChunkName: "teams" */ '@/views/teams/TeamsWorkSpace.vue'
        ),
      meta: { requiresAuth: false } // Public workspaces don't require auth
    },
    {
      path: '/workspace/store',
      name: 'WorkspaceStore',
      component: () =>
        import(
          /* webpackChunkName: "workspace" */ '@/views/pages/workspace/WorkspaceStore.vue'
        )
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import(/* webpackChunkName: "main" */ '@/views/Search'),
      meta: { requiresAuth: true }
    },
    {
      path: '/share',
      name: 'Share',
      component: () => import(/* webpackChunkName: "main" */ '@/views/Share')
    },
    {
      path: '/policy',
      name: 'Policy',
      component: () =>
        import(/* webpackChunkName: "pages" */ '@/views/pages/policy')
    },
    {
      path: '/terms',
      name: 'Terms & Conditions',
      component: () =>
        import(/* webpackChunkName: "pages" */ '@/views/pages/terms')
    },
    {
      path: '/digital-business-cards',
      name: 'DigitalBusinessCard',
      component: () =>
        import(
          /* webpackChunkName: "advertise" */ '@/views/pages/advertisement/digitalBusinessCards.vue'
        )
    },
    {
      path: `/${process.env.VUE_APP_PROMO_SLUG}/:id`,
      name: 'AdvertPage',
      component: () =>
        import(
          /* webpackChunkName: "advertise" */ '@/views/pages/advertisement/AdvertPage.vue'
        ),
      props: true
    },
    {
      path: '/bookmark-management',
      name: 'Bookmark Management',
      component: () =>
        import(
          /* webpackChunkName: "bookmarks" */ '@/views/pages/bookmark-management'
        )
    },
    {
      path: '/bookmark-guide',
      name: 'Bookmark Guide',
      component: () =>
        import(
          /* webpackChunkName: "bookmarks" */ '@/views/pages/bookmark-guide'
        )
    },
    {
      path: '/export-bookmarks',
      name: 'Export Bookmarks',
      component: () =>
        import(
          /* webpackChunkName: "bookmarks" */ '@/views/pages/export-bookmarks'
        )
    },
    {
      path: '/import-bookmarks',
      name: 'Import Bookmarks',
      component: () =>
        import(
          /* webpackChunkName: "bookmarks" */ '@/views/pages/import-bookmarks'
        )
    },
    {
      path: '/subscriptions/starter',
      name: 'Starter Subscription',
      component: () =>
        import(
          /* webpackChunkName: "subscriptions" */ '@/views/pages/subscriptions/StarterSubscription.vue'
        )
    },
    {
      path: '/subscriptions/pro',
      name: 'Pro Subscription',
      component: () =>
        import(
          /* webpackChunkName: "subscriptions" */ '@/views/pages/subscriptions/ProSubscription.vue'
        )
    },
    {
      path: '/subscriptions/business',
      name: 'Business Subscription',
      component: () =>
        import(
          /* webpackChunkName: "subscriptions" */ '@/views/pages/subscriptions/BusinessSubscription.vue'
        )
    },
    {
      path: '/subscriptions/enterprise',
      name: 'Enterprise Subscription',
      component: () =>
        import(
          /* webpackChunkName: "subscriptions" */ '@/views/pages/subscriptions/EnterpriseSubscription.vue'
        )
    },
    {
      path: '/ai-recommendations',
      name: 'AIRecommendations',
      component: () =>
        import(/* webpackChunkName: "ai" */ '@/views/AIRecommendations'),
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Record referer URL in state
  await store.dispatch('setRefererUrl', from.fullPath)

  // Handle redirection to the token auth page
  if (to.fullPath.startsWith('/teams/workspace/auth')) {
    await store.dispatch('setAuthTokenRefererUrl', to.fullPath)
    // If user is not logged in, redirect to login
    if (!firebase.auth().currentUser) {
      // Save the auth URL as the referer URL before redirecting
      await store.dispatch('setRefererUrl', to.fullPath)
      return next({ name: 'Login' })
    }
  }

  // Check if the route requires authentication
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    let user = firebase.auth().currentUser
    if (user) {
      try {
        // Ensure permissions are loaded (Firebase automatically refreshes tokens as needed)
        const permissionsLoaded = await ensurePermissionsLoaded()
        if (!permissionsLoaded) {
          throw new Error('Permissions could not be loaded')
        }

        // If user is authenticated, proceed
        next()
      } catch (error) {
        next({ name: 'Login' })
      }
    } else {
      // No user signed in, redirect to login
      next({ name: 'Login' })
    }
  } else {
    next() // Route doesn't require auth, proceed
  }
})

async function ensurePermissionsLoaded() {
  // Wait until permissions are populated
  while (!Object.keys(store.state.auth.permissions).length) {
    await new Promise(resolve => setTimeout(resolve, 50)) // Wait for 50ms
  }
  return true
}

export default router
